import ih from 'immutability-helper';
import * as types from './actionTypes';
import initialState from './initialState';

const ruleEntitiesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_RULE_ENTITIES_REQUEST:
      return ih(state, {
        list: {
          isLoading: {
            $set: true,
          },
        },
      });
    case types.GET_RULE_ENTITIES_SUCCESS:
      return ih(state, {
        list: {
          isLoading: {
            $set: false,
          },
          data: {
            items: {
              $set: action.payload.list,
            },
            count: {
              $set: action.payload.count,
            },
          },
        },
      });
    case types.GET_RULE_ENTITIES_ERROR:
      return ih(state, {
        list: {
          isLoading: {
            $set: false,
          },
          error: {
            $set: action.payload.error,
          },
        },
      });
    default:
      return state;
  }
};

export default ruleEntitiesReducer;
